import { VERIFICATION_METHOD } from '../../domain/domainCodes.js'
/**
 * Legacy strings for قائمة المنظمات, رخصة الاستخدام, معلومات المنظمة and معلومات الترخيص —
 * Admin/ManageCompanies.ar.resx, Admin/LicenseManagement.ar.resx,
 * Admin/CompanyProfile.ar.resx, Admin/LicenseInformation.ar.resx and Admin/Sitemap.ar.resx.
 */

export const companiesStrings = {
  title: 'قائمة المنظمات', // Sitemap.ManageCompanies_Title
  panel: 'ادارة الشركات', // ManageCompanies.CompanyManagementResource_Text

  columns: {
    arabicName: 'الاسم العربي', // BoundFieldResource1_HeaderText
    englishName: 'الاسم الإنجليزي', // BoundFieldResource2_HeaderText
    isActive: 'منشط', // CheckBoxFieldResource1_HeaderText
    users: 'المستخدمين', // TemplateFieldResource1_HeaderText
    profile: 'ملف المنظمة', // TemplateFieldResource2_HeaderText
    /* Not legacy — both are on the API's row and the table never showed either. */
    email: 'البريد الإلكتروني',
    registeredOn: 'تاريخ التسجيل',
  },

  loadFailed: 'تعذر تحميل المنظمات',

  active: 'نشط', // inline in the view
  inactive: 'غير نشط', // inline in the view
  viewUsers: 'مشاهدة', // userLinkResource1_Text
  viewProfile: 'البروفايل', // profileLinkResource1_Text
  delete: 'حذف', // CommandFieldResource1_DeleteText
  deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر', // Label3Resource1_Text
  yes: 'نعم', // btnYesResource1_Text
  no: 'لا', // btnNoResource1_Text
  close: 'إغلاق', // Users.btnClose
  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  deleteFailed: 'فشلت العملية', // operationFailed

  usersModal: {
    title: 'مشاهدة', // userLinkResource1_Text — the dialog reuses the link text
    index: 'م', // Users_HeaderText1
    username: 'اسم المستخدم', // Users_HeaderText2
    arabicName: 'الاسم بالعربية', // Users_HeaderText3
    englishName: 'الاسم بالإنجليزية', // Users_HeaderText4
    email: 'البريد', // Users_HeaderText5
    empty: 'لا يوجد مستخدمون في هذه المنظمة',
  },
}

export const licenseManagementStrings = {
  saveUnavailable: 'حفظ الرخصة غير متاح بعد — لا توجد خدمة تستقبل هذه البيانات.',
  title: 'إدارة رخصة الاستخدام', // LicenseManagement.PageResource1_Title
  panel: 'إعدادات رخصة النظام', // labelTitle_Text
  create: 'انشاء', // btnCreateResource1_Text
  /* Not legacy — the licence book listed twelve clients with no sense of how
     much had been sold or how much of it is still live. */
  summary: {
    clients: 'العملاء',
    seats: 'إجمالي المقاعد',
    live: 'تراخيص سارية',
  },

  save: 'حفظ', // EditQuestions.EditQuestion — the modal's submit button
  emptyMessage: 'لا يوجد شركات لديها رخصة بعد', // grdVwCompaniesLicencesResource1_EmptyDataText

  columns: {
    company: 'العميل', // lblCompaniesResource1_Text
    licenseType: 'نوع الرخصة', // lblLicenceTypeResource1_Text
    usersNumber: 'عدد المستخدمين', // NumberOfUsersLabelResource1_Text
    startDate: 'تاريخ البداية', // StartDateLabelResource1_Text
    duration: 'الفترة (بالأيام)', // DurationLabelResource1_Text
  },

  form: {
    company: 'العميل', // lblCompaniesResource1_Text
    passKey: 'كلمة المرور', // PassKeyLabelResource1_Text
    startDate: 'تاريخ البداية', // StartDateLabelResource1_Text
    licenseType: 'نوع الرخصة', // lblLicenceTypeResource1_Text
    usersNumber: 'عدد المستخدمين', // NumberOfUsersLabelResource1_Text
    duration: 'الفترة (بالأيام)', // DurationLabelResource1_Text
    minMaxUsers: 'لابد أن يكون عدد المستخدمين بين مستخدم واحد و 9999999 مستخدم', // MinMaxUsersCountMessage
    minMaxDuration: 'لابد أن يكون عدد الأيام بين يوم واحد و 9999999 يوم', // MinMaxDurationMessage
  },

  /**
   * setLicenseProp — which of the two numeric fields a licence type enables.
   * 1 Open and 2 Close lock both, 3 TimeStamp opens the duration only,
   * 4 NumberOfUsers opens the seat count only, 5 opens both.
   */
  typeFields: {
    [VERIFICATION_METHOD.OPEN]: { users: false, duration: false },
    [VERIFICATION_METHOD.CLOSE]: { users: false, duration: false },
    [VERIFICATION_METHOD.TIME_STAMP]: { users: false, duration: true },
    [VERIFICATION_METHOD.NUMBER_OF_USERS]: { users: true, duration: false },
    [VERIFICATION_METHOD.NUMBER_OF_USERS_AND_TIME_STAMP]: { users: true, duration: true },
  },

  edit: 'تعديل', // btnEditResource1_ToolTip
  close: 'إغلاق', // Users.btnClose
  saved: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  /* Only when the request itself failed; a refusal arrives in the server's words. */
  saveFailed: 'تعذر الحفظ، فضلا حاول مرة أخرى',
}

export const companyProfileStrings = {
  title: 'معلومات المنظمة', // Sitemap.CompanyProfile_Title
  subtitle: 'تعديل', // Groups.btnEdit

  // Read by the screen and never defined — a refused save showed an empty toast.
  saveFailed: 'تعذر إتمام العملية',

  // The screen had no failure path at all — see the note in CompanyProfilePage.
  errorHeading: 'رسالة الخطأ',
  loadFailed: 'تعذر تحميل معلومات المنظمة',

  /* Section headings — the legacy lays the fields out in three unnamed columns. */
  sections: {
    identity: 'هوية المنظمة',
    contact: 'بيانات التواصل',
    access: 'الدخول والتسجيل',
  },

  englishName: 'الاسم بالإنجليزية', // CompanyProfile.Label1Resource1_Text
  arabicName: 'الاسم بالعربية', // Label3Resource1_Text
  email: 'بريد المنظمة', // CompanyEmail_Text
  supportEmail: 'بريد الدعم الفني', // LocSupportEmail
  supportPhone: 'هاتف الدعم الفني', // LocSupportPhone
  authMethod: 'طريقة الدخول للنظام', // Label6Resource1_Text
  licenseType: 'رخصه النظام', // Label7Resource1_Text
  activation: 'تفعيل الحساب', // ActivationsLabelResource1_Text
  byEmail: 'بالبريد', // ByEmailResource1_Text
  byAdmin: 'بواسطة المدير', // ByAdminResource1_Text
  emailOnDomain: 'البريد يجب أن يكون بداخل دومين المنظمة', // InsideDomainResource1_Text
  domains: 'دومين المنظمة', // Label5Resource1_Text
  registerLinkLabel: 'انسخ رابط التسجيل', // Label2Resource1_Text
  registerLink: 'التسجيل', // regLinkResource1_Text
  update: 'تحديث المعلومات', // UpdateButtonResource1_Text
  close: 'إغلاق', // Users.btnClose
  saved: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}

export const licenseInformationStrings = {
  title: 'معلومات الترخيص', // LicenseInformation.PageResource1_Title
  subtitle:
    'تحتوي هذه الصفحة على كل ما يتعلق برخصة النظام الحالية و تاريخ التراخيص السابق الخاصة بك', // MainPanelSubHeader
  current: 'الترخيص الحالي', // LabelResource1_Text
  previous: 'التراخيص السابقة', // LabelResource2_Text
  renew: 'تجديد الترخيص', // CardHeaderLicenseRenew
  licenseFile: 'ملف الرخصة', // LicenseFile
  save: 'حفظ', // CertificateSettings.BtnSave

  fields: {
    company: 'المنظمة', // TemplateFieldResource1_HeaderText
    licenseType: 'نوع الترخيص', // TemplateFieldResource2_HeaderText
    startDate: 'تاريخ البدء', // TemplateFieldResource3_HeaderText
    duration: 'المدة', // TemplateFieldResource4_HeaderText
    daysLeft: 'الأيام المتبقية', // TemplateFieldResource5_HeaderText
    expirationDate: 'تاريخ الانتهاء', // TemplateFieldResource6_HeaderText
    accounts: 'الحسابات', // TemplateFieldResource7_HeaderText
    consumedAccounts: 'الحسابات المستخدمة', // TemplateFieldResource8_HeaderText
    remainingAccounts: 'الحسابات المتبقية', // TemplateFieldResource9_HeaderText
  },

  /* The other half of "الأيام المتبقية" — the legacy prints the remainder and
     the duration but never names the part between them. */
  elapsed: 'الأيام المنقضية',

  history: {
    licenseType: 'نوع الترخيص', // TemplateFieldResource13_HeaderText
    startDate: 'تاريخ البدء', // TemplateFieldResource14_HeaderText
    duration: 'المدة', // TemplateFieldResource15_HeaderText
    accounts: 'الحسابات', // TemplateFieldResource16_HeaderText
  },

  unavailable: '—',
}
